import { Component, Input, OnDestroy, OnInit } from "@angular/core";
import {
  Aangifte,
  BokkzAlgDataService,
  Heffingskortingen,
  IncomeTaxEntity
} from "@snelstart-ventures/fiscaal/domain-logic";
import {FormBuilder, FormGroup} from "@angular/forms";
import {BokkzIbDataService} from "@snelstart-ventures/fiscaal/domain-logic";
import { BehaviorSubject, filter, Subscription } from "rxjs";
import { Event, NavigationEnd, Router } from "@angular/router";
import { SharedUiFormControlsModule } from '@snelstart/ui-form-controls';
import { SharedUiDetailsModule } from '@snelstart/ui-details';

@Component({
  selector: 'snelstart-venture-fiscaal-feature-iack-info',
  templateUrl: './iack-info.component.html',
  styleUrls: ['./iack-info.component.scss'],
  imports: [
    SharedUiFormControlsModule,
    SharedUiDetailsModule
  ]
})
export class IackInfoComponent implements OnInit, OnDestroy {
    private routerSubscription: Subscription | undefined;
    private incomeTaxEntitySubscription: Subscription | undefined;
    private clientEntitySubscription: Subscription | undefined;
    private isSaving = false;
    private clientId!: string;

    @Input() public id!: string;
    public aangifte = {} as Aangifte;
    public incomeTaxEntity = {} as IncomeTaxEntity;

    public partnerBoolean = {} as boolean;
    @Input() partner = new BehaviorSubject<boolean>(false);
    private partnerAangifte = {} as Aangifte

    public isDefAangifte ={} as boolean;

    public iackKorting = this.fb.group<Heffingskortingen>({});

    constructor(public dataService: BokkzIbDataService, public dataAlgService: BokkzAlgDataService,
                private router: Router,
                private fb: FormBuilder) {
        this.iackKorting = this.createIACKFormGroup();
    }

    public createIACKFormGroup(iack?: Heffingskortingen) {
        return this.fb.group<Heffingskortingen>({
            arbeidsInkomenPartner: iack?.arbeidsInkomenPartner || null,
            verzamelInkomenPartner: iack?.verzamelInkomenPartner || null,
            geboortedatumPartner: iack?.geboortedatumPartner || null,
        } as Heffingskortingen);
    }



    public ngOnInit(): void {
        this.incomeTaxEntitySubscription = this.dataService.incomeTaxEntity.subscribe((incomeTaxEntity) => {
            this.incomeTaxEntity = incomeTaxEntity;
            if (incomeTaxEntity.aangifte) {
                const aangifte = incomeTaxEntity.aangifte as Aangifte;
                const arb = aangifte?.heffingskortingen?.arbeidsInkomenPartner || null;
                const verz = aangifte?.heffingskortingen?.verzamelInkomenPartner || null;
                const geb = aangifte?.heffingskortingen?.geboortedatumPartner || null;
                this.aangifte=incomeTaxEntity.aangifte
                this.iackKorting.patchValue(
                  { geboortedatumPartner: geb,
                    arbeidsInkomenPartner: arb,
                    verzamelInkomenPartner: verz
                  },{emitEvent:false});
            }
        });
      this.dataAlgService.client.subscribe((client) =>{
        this.clientId=client.sstRelationId!;
      })
      this.routerSubscription = this.router.events.pipe(filter((event: Event): event is NavigationEnd => event instanceof NavigationEnd))
        .subscribe((event: NavigationEnd) => {
          this.handleUrlChange(event.urlAfterRedirects);
        });
    }

  ngOnDestroy(): void {
    if (this.routerSubscription) {
      this.routerSubscription.unsubscribe(); // Unsubscribe to avoid memory leaks
    }
    if (this.incomeTaxEntitySubscription) {
      this.incomeTaxEntitySubscription.unsubscribe();
    }
    if (this.clientEntitySubscription) {
      this.clientEntitySubscription.unsubscribe();
    }
  }

  handleUrlChange(newUrl: string) {
    if (!this.isSaving) {
      this.isSaving = true;
      this.dataService.postIncomeTaxEntity(this.clientId, false, this.incomeTaxEntity);
      this.isSaving = false;
    }
  }

    saveForm(): void {
      setTimeout(()=>{
        this.incomeTaxEntity.aangifte = {
          ...this.aangifte,
          heffingskortingen: {
            ...this.aangifte.heffingskortingen,
            geboortedatumPartner: this.aangifte.partnerAangifte?.aangever?.geboortedatum,
            arbeidsInkomenPartner: this.iackKorting.controls.arbeidsInkomenPartner?.getRawValue(),
            verzamelInkomenPartner: this.iackKorting.controls.verzamelInkomenPartner?.getRawValue(),
          }
        } as Aangifte;
        this.dataService.updateIncomeTaxEntity(this.incomeTaxEntity);
      },0)
    }
}
